<section class="testimonials-wrapper">
  <div class="bg-shape"></div>
  <!-- <div class="header-content">
    <span class="badge">Testimonials</span>
    <h2>What WoW Health Users are Saying</h2>
    <p class="subtitle">
      Hear from members enjoying affordable, transparent care every day. 
      Transparent pricing is changing their healthcare experience.
    </p>
  </div> -->

  <div class="carousel-viewport" 
     (touchstart)="onTouchStart($event)" 
     (touchmove)="onTouchMove($event)" 
     (touchend)="onTouchEnd()">
    <div class="carousel-track" 
         [style.transform]="'translateX(calc(-' + currentIndex + ' * (var(--card-width) + 20px)))'">
      
      <div class="testimonial-card" *ngFor="let item of slides" 
      [style.--img-url]="'url(' + item.bgImage + ')'"
      [style.backgroundImage]="'url(' + item.bgImage + ')'" 
      [style.backgroundSize]="'cover'" 
      [style.backgroundPosition]="'center'" 
      [style.backgroundRepeat]="'no-repeat'">
        <div class="content-block">
            <h2>{{ item.title }}</h2>
            <p>{{ item.description }}</p>
        </div>
      </div>

    </div>
  </div>

  <div class="pagination">
    <button class="dot" *ngFor="let dot of dots" [class.active]="dot === currentIndex" (click)="goToSlide(dot)"></button>
  </div>
</section>
